import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { scrollPageToTop } from '@backrs_ui/grow-ui/src/utils/scrollReveal';

export const useScrollToTopOnNavigation = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // A hash points at an in-page anchor, which owns the scroll position.
    if (hash) return;

    scrollPageToTop();
  }, [pathname, hash]);
};
